import request from '@/utils/request'

/**
 * 获取产品中心页面所有公开数据
 */
export function getPublicProductAll() {
  return request({
    url: '/cms/product/public/all',
    method: 'get'
  })
}
